<h2 mat-dialog-title>Przyjęto zlecenie synchronizacji</h2>

<p>Może to potrwać kilka minut.</p>
<p>Następna synchronizacja będzie możliwa za 30 minut.</p>

<mat-dialog-actions align="start">
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
